import { ItemsListRowItemBase } from '../list-row-item-base';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'fi-items-list-row-item-actions',
    templateUrl: './actions.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemActionsComponent extends ItemsListRowItemBase {}
